module.exports = __webpack_public_path__ + "29cfdb3a34de7f56c6f3b92afdda3f01.svg";